export default "__VITE_ASSET__CMPCJ0_o__"